import { render, staticRenderFns } from "./TflStatus.vue?vue&type=template&id=06c1769f&scoped=true&"
import script from "./TflStatus.vue?vue&type=script&lang=js&"
export * from "./TflStatus.vue?vue&type=script&lang=js&"
import style0 from "./TflStatus.vue?vue&type=style&index=0&id=06c1769f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c1769f",
  null
  
)

export default component.exports